export default __webpack_public_path__ + "static/media/users.532d8a67.png";